import styled, { css } from 'styled-components';

import { getPurpurColor, getPurpurShadow, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import { InputVariant } from '../../model';

type WrapperProps = {
    $variant?: InputVariant;
};

export const SuggestionsWrapper = styled.div<WrapperProps>`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    text-align: left;
    z-index: 1000;
    border: 1px solid ${getPurpurColor('gray50')};
    border-bottom-left-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
    box-shadow: ${getPurpurShadow('md')};
    background-color: ${getPurpurColor('functionalWhite')};

    ${({ $variant }) =>
        $variant === 'gray' &&
        css`
            background-color: ${getPurpurColor('gray50')};
            box-shadow: none;
            border-radius: 0 0 0.5rem 0.5rem;
        `};
`;

export const SuggestionsContainer = styled.ul`
    max-height: 15.5rem;
    overflow: auto;
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const SuggestionItem = styled.li`
    padding-top: ${getPurpurSpacing('150')};
    padding-bottom: ${getPurpurSpacing('150')};
    padding-left: ${getPurpurSpacing('100')};
    padding-right: ${getPurpurSpacing('100')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid ${getPurpurColor('gray300')};

    &.focused,
    &:hover {
        background-color: ${getPurpurColor('gray50')};
    }

    &:last-child {
        border-bottom: none;
    }
`;
